import { transformIfLocked } from 'components/QuestionnaireRequestAutomated/utilities/processor'
import Boolean from 'components/form_field/types/boolean'
import Color_list from 'components/form_field/types/color_list'
import Date from 'components/form_field/types/date'
import Duration from 'components/form_field/types/duration'
import Email from 'components/form_field/types/email'
import Measure_and_units from 'components/form_field/types/measure_and_units'
import Number from 'components/form_field/types/number'
import Phone from 'components/form_field/types/phone'
import Slider from 'components/form_field/types/slider'
import Static from 'components/form_field/types/static'
import Text from 'components/form_field/types/text'
import Time from 'components/form_field/types/time'
import USStates from 'components/form_field/types/us_states'
import File from 'components/form_field/types/file'
import React from 'react'
import MoneyField from './moneyField'
import { OptionsField } from './optionsField'
import { SelectField } from './selectField'

export default function QuestionField(props) {
  // If the field is locked or system only, then it must just be a value
  props = transformIfLocked(props)

  const { type } = props.field || {}

  const classes = ['field', `form-field-${type}-type`].join(' ')

  switch (type) {
    case 'measure-and-units':
      return <Measure_and_units className={classes} {...props} />
    case 'text':
      return <Text className={classes} {...props} />
    case 'email':
      return <Email className={classes} {...props} />
    case 'phone':
      return <Phone className={classes} {...props} />
    case 'number':
      return <Number className={classes} {...props} />
    case 'money':
      return <MoneyField className={classes} {...props} />
    case 'boolean':
      return <Boolean className={classes} {...props} />
    case 'time':
      return <Time className={classes} {...props} />
    case 'date':
      return <Date className={classes} {...props} />
    case 'duration':
      return <Duration />
    case 'options':
      return <OptionsField className={classes} {...props} />
    case 'select':
      return <SelectField className={classes} {...props} />
    case 'us-states':
      return <USStates className={classes} {...props} />
    case 'slider':
      return <Slider className={classes} {...props} />
    case 'color-list':
      return <Color_list className={classes} {...props} />
    case 'file':
      return <File className={classes} {...props} />
  }

  return <Static className={classes} {...props} />
}
